import React, { useState } from "react";
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  const phoneNumber = "255745236991";
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const companyProfile = {
    name: "LilyVentures Limited",
    status: "Online",
    avatarUrl: process.env.PUBLIC_URL + "/assets/img/logo/logo.jpg",
  };

  const openPopup = () => setIsOpen(true);
  const closePopup = () => {
    setMessage("");
    setError("");
    setIsOpen(false);
  };
  

  const handleSend = () => {
    // if (!message.trim()) {
    //   alert("Please enter a message");
    //   return;
      // }
    if (!message.trim()) {
      setError("Oops! Please enter your message.");
      setTimeout(() => setError(""), 2000);
      return;
    }
      setError("")
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
    setIsOpen(false);
  };

  return (
    <>
      <button className="whatsapp-float-left" onClick={openPopup}>
        <img
          src={process.env.PUBLIC_URL + "/assets/img/whatsappicon.png"}
          alt="WhatsApp"
          className="whatsapp-icon"
        />
        <span className="whatsapp-text">Contact</span>
      </button>

      {isOpen && (
        <div className="whatsapp-popup-overlay" onClick={closePopup}>
          <div className="whatsapp-popup" onClick={(e) => e.stopPropagation()}>
            {/* Company Profile Header */}
            <div className="whatsapp-chat-header">
              <img
                src={companyProfile.avatarUrl}
                alt={companyProfile.name}
                className="whatsapp-company-avatar"
              />
              <div className="whatsapp-company-info">
                <h4>{companyProfile.name}</h4>
                <span className={`status ${companyProfile.status === "Online" ? "online" : "offline"}`}>
                  {companyProfile.status}
                </span>
              </div>
            </div>

            {/* Message input area */}
            <textarea
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type your message here..."
              autoFocus
            />
{error && <div className="whatsapp-error">{error}</div>}
            <div className="whatsapp-popup-buttons">
              <button onClick={handleSend} className="whatsapp-send-btn">
                Send
              </button>
              <button onClick={closePopup} className="whatsapp-cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
